import { render } from "./EditBusinessModal.vue?vue&type=template&id=6b255130&scoped=true"
import script from "./EditBusinessModal.vue?vue&type=script&lang=js"
export * from "./EditBusinessModal.vue?vue&type=script&lang=js"

import "./EditBusinessModal.vue?vue&type=style&index=0&id=6b255130&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b255130"]])

export default __exports__